import { render, staticRenderFns } from "./TablesList.vue?vue&type=template&id=27942e02&scoped=true&"
import script from "./TablesList.vue?vue&type=script&lang=js&"
export * from "./TablesList.vue?vue&type=script&lang=js&"
import style0 from "./TablesList.vue?vue&type=style&index=0&id=27942e02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27942e02",
  null
  
)

export default component.exports